import React from "react"
import PropTypes from "prop-types"
import * as styles from "./WrapperWithTabbingImageCard-tw-styles"
import ImageCardsLayout from "../ImageCardsLayout/ImageCardsLayout"

const WrapperWithTabbingImageCard = props => {
  const { imageCardLayout, variant } = props
  const style = styles[variant] || styles.defaultStyle

  return (
    <div>
      <div className="">
        <div className="">
          <div>
            <div className="">
              {ImageCardsLayout && <ImageCardsLayout {...imageCardLayout} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

WrapperWithTabbingImageCard.propTypes = {
  imageCardLayout: PropTypes.object,
  variant: PropTypes.string,
}

export default WrapperWithTabbingImageCard
